<!DOCTYPE html>
<head>
<meta name="viewport" content="width=device-width, initial-scale=1">
</head>
<ng-container *ngIf="user">
  <app-toolbar [title]="title"  [user]="user" [back]="true" [destination]="destination"></app-toolbar>
</ng-container>

<app-bar-chart-stable-unstable-duration-crohn></app-bar-chart-stable-unstable-duration-crohn>
<app-bar-chart-stable-unstable-duration-uc></app-bar-chart-stable-unstable-duration-uc>